import { Collapse, Row, Col, Progress } from 'antd';
import React from 'react';
import { CaretRightOutlined } from '@ant-design/icons';
import Title from 'components/Title';
import { TpAuthorizationResponse } from 'services/thirdParty';
import GetLabel from 'DisplayFramework/components/GetLabel';
import { toCurrency } from 'utils/utils';
import ParListSelect from 'components/ParListSelect';
import FormInput from 'components/FormInput';
import SaveButton from 'components/SaveButton';

const { Panel } = Collapse;

export type OptionsSFSProps = {
  id: number;
  tpauthlist: TpAuthorizationResponse[];
};

const OptionsSFS = ({ id, tpauthlist }: OptionsSFSProps) => {
  let tpAuthList = tpauthlist?.filter((tp) => tp.authstatus === 'ACTIVE');

  let tpAuthDetails = tpAuthList?.flatMap((tp) => tp.authDetail);

  return (
    <Collapse
      bordered={false}
      expandIcon={({ isActive }) => (
        <CaretRightOutlined
          style={{ fontSize: 24, float: 'left' }}
          rotate={isActive ? 90 : 0}
        />
      )}
      expandIconPosition="start"
      defaultActiveKey={['1']}
    >
      {tpAuthDetails?.map((auth, index) => {
        let availableamount = (
          (1 - auth.authdetailavailableamount / auth.authdetailamount) *
          100
        ).toFixed(2);

        return (
          <>
            <Panel
              header={<Title level={5} comcode={auth.offerlabel}></Title>}
              key={auth.authdetailid}
              style={{
                marginBottom: 24,
                overflow: 'hidden',
                background: '#f7f7f7',
                border: 10,
                borderRadius: 2,
                boxShadow:
                  'rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
              }}
            >
              <Row gutter={16}>
                <Col span={4}>
                  <Row style={{ marginBottom: '5%' }}>
                    <Col xs={24}>
                      <FormInput name="Activite autorisée" initialValue="OUI" />
                    </Col>
                  </Row>
                  <Row style={{ marginBottom: '5%' }}>
                    <Col xs={24}>
                      <FormInput
                        name="Perméabilite autorisée"
                        initialValue="NON"
                      />
                    </Col>
                  </Row>
                  <Row style={{ marginBottom: '5%' }}>
                    <Col xs={24}>
                      <FormInput name="Saisonalite Active" initialValue="NON" />
                    </Col>
                  </Row>
                  <Row style={{ marginBottom: '5%' }}>
                    <Col xs={24}>
                      <FormInput name="Suractivite Active" initialValue="NON" />
                    </Col>
                  </Row>
                </Col>
                <Col span={12}>
                  <Row
                    gutter={80}
                    style={{ marginBottom: '5%', marginLeft: '5%' }}
                  >
                    <Col xs={12}>
                      <FormInput
                        name="authdetailamount"
                        initialValue={toCurrency(
                          auth.authdetailamount,
                          auth.currcode ?? localStorage.getItem('currcode')
                        )}
                      />
                      <Progress
                        percent={parseFloat(availableamount)}
                        strokeWidth={20}
                        strokeLinecap="square"
                        strokeColor={
                          parseFloat(availableamount) <= 50
                            ? 'green'
                            : parseFloat(availableamount) <= 80
                            ? 'yellow'
                            : 'red'
                        }
                        format={(percent) => (
                          <span style={{ color: 'white' }}>{percent}%</span>
                        )}
                      />
                    </Col>
                    <Col xs={12}>
                      {/* <Input
                      className="square-input"
                      addonBefore="authdetailamountmpea"
                      defaultValue={toCurrency(
                        auth.authdetailamount,
                        auth.currcode ?? localStorage.getItem('currcode')
                      )}
                      style={{ backgroundColor: '#243882 !important' }}
                    /> */}
                    </Col>
                  </Row>
                  <Row
                    justify="center"
                    style={{
                      color: '#243882',
                      fontWeight: 'bold',
                      marginBottom: '5%',
                    }}
                  >
                    <GetLabel label="CONSOMMATIONS" />
                  </Row>
                  <Row style={{ marginBottom: '5%' }} gutter={80}>
                    <Col span={8} xs={12}>
                      <FormInput
                        name="authdetailbookedamount"
                        initialValue={toCurrency(
                          auth.authdetailbookedamount,
                          auth.currcode ?? localStorage.getItem('currcode')
                        )}
                      />

                      <FormInput
                        name="authdetailusedamount"
                        initialValue={toCurrency(
                          auth.authdetailusedamount,
                          auth.currcode ?? localStorage.getItem('currcode')
                        )}
                      />
                    </Col>
                    <Col span={12}>
                      <FormInput
                        name="totalconsomme"
                        initialValue={toCurrency(
                          auth.authdetailusedamount +
                            auth.authdetailbookedamount,
                          auth.currcode ?? localStorage.getItem('currcode')
                        )}
                      />
                      <FormInput
                        name="authdetailavailableamount"
                        initialValue={toCurrency(
                          auth.authdetailavailableamount,
                          auth.currcode ?? localStorage.getItem('currcode')
                        )}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row>
                <Col xs={12}>
                  <FormInput name="authdetailavailableamount">
                    <ParListSelect parcode="LIMITCTRL" />
                  </FormInput>
                </Col>
              </Row>
            </Panel>
            <Row gutter={12} justify="center">
              <Col span={!Number(id) ? 5 : 4}>
                <SaveButton
                  comcode="Annuler"
                  custom={{ height: 45 }}
                  onClick={() => {}}
                />
              </Col>
              <Col span={!Number(id) ? 5 : 4}>
                <SaveButton
                  comcode="Enregistrer"
                  custom={{ height: 45 }}
                  onClick={() => {}}
                />
              </Col>
            </Row>
          </>
        );
      })}
    </Collapse>
  );
};

export default OptionsSFS;
